import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  selectedSite: {},
};

export const SiteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {
    changeSite: (state: any, action: any) => {
      state.selectedSite = action.payload;
    },
  },
});

export const { changeSite } = SiteSlice.actions;

export default SiteSlice.reducer;
